import { map, type OperatorFunction } from 'rxjs';

export class DtoServiceListDataMapperFactory {
  static create<DATA_DTO, DTO extends { data: DATA_DTO[] | null } = { data: DATA_DTO[] | null }>(
    mapper: (dto: DATA_DTO) => DATA_DTO,
  ): { operator: () => OperatorFunction<DTO, DTO>; mapper: (dto: DATA_DTO) => DATA_DTO } {
    return {
      operator: () =>
        map<DTO, DTO>(response => {
          response.data = response.data?.map(item => mapper(item)) ?? null;

          return response;
        }),
      mapper,
    };
  }
}
